var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-element-loading',{class:{active: _vm.active},attrs:{"active":_vm.active,"color":"rgba(var(--vs-primary), 1)","spinner":"mini-spinner","text":_vm.text,"text-style":{'font-weight': 'bold'}}})
}
var staticRenderFns = []

export { render, staticRenderFns }